var map = {
	"./alaska.mp4": "b4fa",
	"./alex.mp4": "f958",
	"./anna.mp4": "1d2d",
	"./frances.mp4": "1a4f",
	"./kama.mp4": "80c8",
	"./lisa.mp4": "0550",
	"./malik.mp4": "c586",
	"./maryse.mp4": "8a98",
	"./momenta_en.mp4": "7028",
	"./momenta_fr.mp4": "f1a8",
	"./sabrina.mp4": "ee04",
	"./scott.mp4": "23ec",
	"./tsema.mp4": "f059"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1a0d";